import { render, staticRenderFns } from "./Page_Contact.vue?vue&type=template&id=3f2776d8&scoped=true&"
import script from "./Page_Contact.vue?vue&type=script&lang=js&"
export * from "./Page_Contact.vue?vue&type=script&lang=js&"
import style0 from "./Page_Contact.vue?vue&type=style&index=0&id=3f2776d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2776d8",
  null
  
)

export default component.exports